import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p style={{ fontSize: "1.1em" }}>
              <p style={{ fontSize: "1.3em" }}>
                <br />
                <b>Inventorying, mapping, and monitoring of ecosystems</b>{" "}
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Changes in the climate, evident from the increase in temperature
                and erratic rainfall regimes, have been posing serious
                challenges to the sustenance of natural resources. The impact
                extends to individual species, influencing their interactions
                with other organisms and their habitats [1], altering the
                structure and functioning of ecosystems, which impacts goods and
                services [2]. A crucial aspect lies in understanding the
                direction and magnitude of ecological responses, enabling human
                communities to predict these changes and adapt proactively
                [3,4]. This entails inventorying, mapping, and monitoring
                ecosystems at regular intervals to update natural resource
                management plans. Additionally, these assessments play a crucial
                role in evaluating the effectiveness of adaptation actions.
                These insights contribute to a better understanding of the
                implications of climate change, enabling informed
                decision-making and strategic planning for sustainable and
                resilient ecosystems.
              </p>
              <p style={{ fontSize: "1.3em" }}>
                &nbsp;<b>Land Degradation</b>{" "}
              </p>
              <p style={{ fontSize: "1.1em" }}>
                India has been experiencing desertification in most states and
                Union territories, and about 97.85 million hectares (29.77%)
                were impacted by land degradation due to the loss of vegetation
                cover and subsequent topsoil erosion accounting for 11.01% of
                degradation in the country in 2018-19, majorly contributed by
                Rajasthan, Maharashtra, Gujarat, Jammu &amp; Kashmir, Karnataka,
                Jharkhand, Odisha, Madhya Pradesh, and Telangana States [5]. The
                most significant process of desertification or land degradation
                in the Goa State is evident from escalating (37.32% in 2011-13
                and 35.74% in 2003- 05) degradation [6].
              </p>
              <p style={{ fontSize: "1.3em" }}>
                &nbsp;
                <b>Goa, Central Western Ghats: Global biodiversity hotspot</b>
              </p>
              <p style={{ fontSize: "1.1em" }}>
                The Central Western Ghats landscape, spanning across Karnataka,
                Goa, and Maharashtra states, is endowed with exceptional
                ecological significance, evident from rich biodiversity,
                perennial rivers, Myristica swamps (with a higher proportion of
                critically endangered and endangered endemic biotic species),
                prominent geological features, captivating beauty, rich cultural
                heritage locations (sacred groves), etc. [7]. Goa state, with
                its exceptionally rich diversity of flora and fauna, hosts a
                diverse array of species across various habitats, including
                forests, coastal areas, and marine ecosystems. Notably, Goa
                harbors about 7% of the endemic flowering plant species found in
                the Western Ghats [8]. The region is home to over 3,000 species
                of plants and flowering trees, including several IUCN Red-listed
                species such as <em>Myristica fatua var. magnifica</em>,{" "}
                <em>Semecarpus kathalekanensis</em>, and{" "}
                <em>Syzygium travancoricum</em> [9]. The mangrove flora in this
                region comprises 15 distinct types distributed across 10 genera
                and 7 families dominated by <em>Rhizophora mucronata</em>,{" "}
                <em>Sonneratia alba</em>, and <em>Avicennia officinalis</em>{" "}
                [10]. The fauna includes about 50 mammal species, such as tigers
                <em>,</em> foxes, wild boars, and guars, along with over 473
                bird species. Among these, 11 species are endemic to the Western
                Ghats, and 19 are threatened species [11]. Additionally, Goa's
                biodiversity encompasses a variety of reptiles, including 23
                snake species, and other reptiles such as crocodiles, lizards,
                and turtles, particularly in mangrove and coastal areas (Goa
                Tourism). The marine ecosystem is equally diverse, with over 224
                fish species, numerous crustaceans like gastropods (86 species),
                bivalves (19 species), shrimps (17 species), crabs (51 species),
                lobsters, and hermit crabs, and a diverse array of mollusks
                [12-14].
              </p>
              <p style={{ fontSize: "1.3em" }}>
                <b>Forest ecosystems</b>{" "}
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Forests are essential ecosystems, covering approximately 30% of
                the earth's surface [15]. The forest ecosystem, with
                interconnected communities of microorganisms, plants, animals,
                soils, water, and climate, interacts with each other in a
                biologically and ecologically integrated manner [16-18]. The
                spatial extent of forests, including tree cover in India, is
                82.74 million hectares, 25.17% of the geographical area [19].
                Quantifying the spatial extent and condition of forest
                ecosystems provides valuable insights into strategic planning to
                ensure the sustainability of natural resources [20]. Alterations
                in the extent or conditions of forests due to unplanned human
                activities have far-reaching impacts on ecosystem services,
                which are crucial for human well-being [21]. Forest
                fragmentation is the process involving the fragmentation of
                contiguous forests into smaller and isolated patches, with
                alterations in the hydrologic regime, microclimate, enhancing
                predation, increasing fire susceptibility, higher instances of
                human-animal conflicts, the decline in plant and animal
                communities, dispersing seeds, and pollinating services
                impacting the sustenance of natural resources [22-26].
                Additionally, fragmentation collectively disrupts vital
                ecological processes, decreases carbon sequestration capability,
                enhances carbon emissions, and exacerbates the negative
                consequences [27, 28].
              </p>
              <p style={{ fontSize: "1.3em" }}>
                <b>Ecosystem services</b>{" "}
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Forests contribute significantly to ecosystem services, offering
                extensive support directly or indirectly to both nature and
                human well-being. They provide various provisioning services,
                such as food, medicine, timber, water, litter, and latex.
                Additionally, forests offer regulating services (carbon
                sequestration, climate change mitigation, air quality
                monitoring, pollination, flood control, and soil productivity)
                as well as cultural services (recreational services, aesthetic
                services) [15, 29, 30]. Carbon sequestration is the pivotal
                service provided by forest ecosystems to regulate global warming
                and make ecosystems more resilient to climate change [31, 32,
                33]. Quantifying carbon emissions and sinks is crucial for
                informed decisions with effective and sustainable forest
                management strategies. Global forests sequester 359 billion
                tonnes of carbon, highlighting the pivotal role in maintaining
                carbon balance [34, 35]. The carbon stock in Indian forest
                ecosystems amounts to 7,204 million tonnes [19], highlighting
                the need for appropriate forest management practices [36].
                Natural capital accounting and valuation of ecosystem services
                (NCAVES) will aid in ascertaining the economic and social
                significance of natural ecosystems [37] through quantification
                of provisioning, regulating, and cultural services and provide
                insights into the cost of environmental degradation and
                associated market failures in the current economic accounting
                [38, 39]. NCAVES is crucial for guiding policy decisions toward
                promoting sustainable resource management, as it enables the
                comparison of ecosystem services with other economic commodities
                [40-42]. Recent research underscores the importance of adopting
                a more holistic approach to value natural assets, highlighting
                their capacity to support prudent decision-making and
                conservation initiatives [39].
              </p>
              <p style={{ fontSize: "1.3em" }}>
                <b>Ecologically Sensitive Regions (ESR)</b>{" "}
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Ecological sensitivity refers to the eternal and irreparable
                loss of extant life forms or significant impairment to the
                natural processes of evolution and speciation with the
                alterations in the ecological integrity of a region [43].
                Alterations in the structure of forest ecosystems due to
                overexploitation of resources, the introduction of invasive
                species, pollution, climate change, etc., will have detrimental
                consequences on the biological, hydrological, and ecological
                functions, leading to the depletion of ecosystem services, which
                poses a significant threat to economic activity and human
                well-being [44-46]. Land degradations induced by changes in land
                use (LU) due to unplanned developmental activities [22] have had
                detrimental effects, leading to a decline in biodiversity and
                disruptions in the hydrological system, thereby compromising the
                sustenance of natural resources [15, 47-51]. The comprehensive
                knowledge of the ecological fragility of a region is
                quintessential for evolving strategies for conserving the area,
                which entails identifying factors responsible for ecological
                sensitiveness, including landscape dynamics, and visualizing
                future transitions to mitigate the problems of haphazard and
                uncontrolled development approaches. Mapping of ecologically
                sensitive regions (ESRs) at disaggregated levels by considering
                the relative significance of landscape (ecosystem extent and
                condition), ecological, bio-geo-climatic, hydrological, energy,
                environmental and social characteristics is essential for
                sustainable planning toward the conservation of the Western
                Ghats, the hottest hotspot of biodiversity [43].
              </p>
              <p style={{ fontSize: "1.3em" }}>
                <b>
                  Assessment of landscape dynamics using spatial data through
                  Machine Learning algorithms
                </b>
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Advancements in geoinformatics with the availability of
                multi-resolution spatial data (remote sensing data) and machine
                learning algorithms have gained significant attention due to
                their robustness and reduced computational time with complex and
                large datasets compared to traditional methods [52, 53].
                Integration of ensemble learning algorithms (ML) for the
                classification of multi-resolution spatial data acquired through
                space-borne sensors (such as Landsat, Sentinel, etc.) has
                enhanced the accuracy of LU classification, which is crucial for
                environmental monitoring through understanding the landscape
                dynamics for informed decisions of sustainable land management
                and policy interventions [54, 55]. Commonly used ensemble
                learning algorithms include Random Forest (R.F.), Support Vector
                Machines (SVM) and Artificial Neural Networks (ANN), in LU
                classification [56-59] and earlier studies have demonstrated
                that among non-parametric supervised classifiers, R.F. performs
                better in the classification of LU for undulating terrain such
                as the Western Ghats using multispectral moderate resolution
                data [60, 61]. R.F. is computationally efficient when dealing
                with large datasets containing more parameters and fewer biases
                than other ML classifiers, which require extensive training on
                large amounts of labeled data and significant computational
                resources [62, 63]. Also, RF provides intrinsic feature
                importance metrics, which are beneficial for understanding the
                contribution of individual features in classification [64-66].
              </p>
              <p style={{ fontSize: "1.3em" }}>
                <b> Prediction of likely land uses</b>
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Inventorying, mapping, change analyses, modeling, and
                visualization of landscape dynamics provide empirical evidence
                of the consequences of spatial changes [50, 67, 68]. Land use
                modeling for visualization of likely land uses would provide
                vital insights for implementing sustainable development
                strategies and preserving biological and cultural diversities
                [68-70]. Predictive statistical and geospatial models for
                landscape dynamics being employed are spatial dynamics models,
                spatial Markov chains (MC), Cellular automata (CA),
                multi-criteria decision-making (MCDM), etc. In this context,
                agent-based modeling (ABM) has been widely used for land use
                modeling, considering diverse characteristics of agents and the
                heterogeneous nature of landscapes within a temporal scale and
                geographical space in a spatially explicit and multi-scale
                manner with the incorporation of social and environmental
                processes in decision-making at disaggregated levels [71, 72].
                Multi-criteria evaluation (MCE) for land use planning involves
                assessing various alternatives by considering multiple factors,
                including environmental impacts, economic viability, and social
                implications. MCE techniques facilitate complex decision-making
                processes through the simultaneous evaluation of multiple
                objectives and constraints [73]. Integration of MCE through a
                range of factors, which is assigned a weight based on its
                relative importance, would help in determining the optimal
                development conditions [74, 75]. Factors considered are (i)
                driving agents with spatial attributes with the potential to
                have a negative or positive impact and (ii) constraints [76,77].
                The Analytic Hierarchy Process (AHP) in MCE uses pair-wise
                comparisons (as a means of measurement) and relies on the
                expertise and judgments of individuals to establish priority
                scales and assess the consistency of importance [78-80].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                AHP [81-84] enables the creation of a hierarchical structure in
                the decision-making process, incorporating both qualitative and
                quantitative factors while allowing the users to determine the
                weights of the factors [83, 85]. AHP offers a framework for
                identifying and rectifying inconsistencies while judging the
                relative importance of factors [86], which aid in selecting the
                most suitable option for predicting likely land-use changes and
                effectively represents individual decision-making with temporal
                and spatial dynamics [87-89].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Forest structure dynamics in the Goa state of Central Western
                Ghats were assessed through temporal land uses to understand the
                impact of (i) the prevalent practice of shifting cultivation
                (slash and burn practice) till the annexation of Goa to the
                Indian Union (1961), (ii) mining in core forest areas during the
                post-independence period, and (iii) unplanned developmental
                activities subsequent to globalization and relaxing markets
                (1990s), which led to the spurt in the anthropogenic activities
                involving large scale infrastructure projects,
                industrialization, etc. Studies pertaining to the assessment of
                the forest structure dynamics with the factors affecting the
                fragmentation, which impacts integrity and biodiversity in Goa,
                are scanty. There is limited research on natural capital
                accounting and valuation of ecosystem services, despite Goa
                being endowed with mangroves and terrestrial forests with rich
                biodiversity and the crucial role of ecosystems in sustaining
                natural resources, which necessitated comprehensive
                interdisciplinary research integrating ecological, economic, and
                social perspectives to support sustainable management of Goa's
                diverse ecosystems. The current study investigates (i) forest
                structure dynamics using temporal remote sensing data (of 1973
                to 2022) in Goa state, Central Western Ghats by employing a
                supervised hierarchical classification based on the Random
                Forest Machine Learning Algorithm, (ii) the condition of forests
                through computation of fragmentation metrics, &nbsp;(iii)
                predicts and geo-visualizes likely land uses in 2038 through MCE
                and the AHP by considering agents of urban development (major
                roads, minor roads, industrial estates, railways, proposed
                layouts) and factors contributing to the degradation of natural
                resources, which will help to evolve strategies for prudent
                natural resources management as per the&nbsp; Sustainability
                Development Goals (SDG) as per the 2030 agenda for Sustainable
                Development, &nbsp;&nbsp;(iv) evaluation of the carbon storage
                potential of the forest ecosystem, (v) prioritization of
                Ecologically Sensitive Regions (ESR) at disaggregated levels,
                and (vi) valuation of forest ecosystem services across various
                levels of ecological sensitivity.
              </p>
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
